// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-profile-icon {
  background-image: url(https://assets.foursightonline.com/app/images/group-profile.png);
  width: 30px;
  background-size: cover;
  height: 23px;
}

.team-report-icon {
  background-image: url(https://assets.foursightonline.com/app/images/team-report-icon.jpg);
  width: 30px;
  background-size: cover;
  height: 23px;
  display: inline-block;
  background-repeat: no-repeat;
}

.gray-scale {
  filter: grayscale(1);
}

.select-color {
  color: #000;
}

.session-actions {
  width: 9%;
  padding: 5px;
  text-align: right;
}
.session-actions a {
  position: static;
  margin-bottom: 0;
}

@media screen and (max-width: 767px) {
  .teams-lists .team-actions .btn-xs {
    display: block;
  }
  .session-actions a {
    margin-bottom: 5px;
  }
  .session-actions a:last-child {
    margin-bottom: 0;
  }
}
@media screen and (max-width: 640px) {
  .page-heading .col-lg-10 {
    width: auto;
  }
  .right-side-btn {
    float: none !important;
    width: 100%;
    text-align: left;
    padding-top: 15px;
    padding-bottom: 15px;
    display: inline-block;
  }
}
@media screen and (max-width: 400px) {
  .table-striped {
    width: 400px;
  }
}
::ng-deep.swal2-icon-text {
  font-size: 1.3em;
  line-height: 1;
}

::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}

td.team-actions {
  min-width: 116px;
}
td.team-actions > a {
  position: relative;
}
td.team-actions .btn-xs:nth-child(2n) {
  left: unset;
}

span.sortby {
  width: 100%;
  height: 100%;
  position: absolute;
  text-align: right;
  left: 0px;
  z-index: 99999;
  padding-right: 14px;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body {
  padding: 20px 30px 30px 30px;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text] {
  width: 100%;
  color: inherit;
  display: block;
  font-size: 14px;
  line-height: 1.4;
  padding: 6px 12px;
  border-radius: 1px;
  background-image: none;
  background-color: #fff;
  border: 1px solid #e5e6e7;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]::-webkit-input-placeholder {
  color: #999;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]:focus, ::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]:focus-visible {
  border-color: #1ab394;
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body.no-pad {
  padding: 0;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  font-size: 12px;
  line-height: 1.5;
  padding: 5px 10px;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--sgrn {
  color: #fff;
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--sgrn:hover {
  border-color: #1dc5a3;
  background-color: #1dc5a3;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}
::ng-deep .modal .hidden {
  display: none;
}

::ng-deep.modal-open {
  overflow: hidden;
}

.teams-lists input:focus, .teams-lists select:focus {
  outline: none;
}

.input-sm:focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/org-individual-sessions/org-individual-sessions.component.scss"],"names":[],"mappings":"AAAA;EACE,sFAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,yFAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,4BAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;AACF;AACE;EACE,gBAAA;EACA,gBAAA;AACJ;;AAGA;EACE;IACE,cAAA;EAAF;EAGA;IACE,kBAAA;EADF;EAIA;IACE,gBAAA;EAFF;AACF;AAKA;EACE;IACE,WAAA;EAHF;EAMA;IACE,sBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,oBAAA;IACA,qBAAA;EAJF;AACF;AAQA;EACE;IACE,YAAA;EANF;AACF;AASA;EACE,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;AASE;EACE,kBAAA;AAPJ;AAUE;EACE,WAAA;AARJ;;AAYA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;AATF;;AAaA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AAVF;AAYE;EACE,yBAAA;AAVJ;AAaE;EACE,oCAAA;AAXJ;AAeI;EACE,mCAAA;AAbN;AAgBI;EACE,UAAA;AAdN;AAmBI;EACE,0BAAA;AAjBN;AAqBE;EACE,kBAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AApBJ;AAsBI;EALF;IAMI,YAAA;IACA,iBAAA;EAnBJ;AACF;AAqBI;EACE,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AAnBN;AAqBM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAnBR;AAqBQ;EACE,aAAA;AAnBV;AAuBM;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AArBR;AAwBM;EACE,4BAAA;EACA,kBAAA;AAtBR;AAyBU;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAvBZ;AA0BU;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,8EAAA;AAxBZ;AA0BY;EACE,WAAA;AAxBd;AA2BY;EAEE,qBAAA;EACA,aAAA;AA1Bd;AA+BQ;EACE,UAAA;AA7BV;AAmCE;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AAjCJ;AAmCI;EACE,qBAAA;EACA,yBAAA;AAjCN;AAoCI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAlCN;AAoCM;EACE,qBAAA;EACA,yBAAA;AAlCR;AAsCI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AApCN;AAsCM;EACE,qBAAA;EACA,yBAAA;AApCR;AAwCI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAtCN;AAwCM;EACE,qBAAA;EACA,yBAAA;AAtCR;AA0CI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAxCN;AA0CM;EACE,qBAAA;EACA,yBAAA;AAxCR;AA6CE;EACE,aAAA;AA3CJ;;AA+CA;EACE,gBAAA;AA5CF;;AAiDI;EACE,aAAA;AA9CN;;AAoDE;EACE,aAAA;AAjDJ","sourcesContent":[".group-profile-icon {\n  background-image: url(https://assets.foursightonline.com/app/images/group-profile.png);\n  width: 30px;\n  background-size: cover;\n  height: 23px;\n}\n\n.team-report-icon {\n  background-image: url(https://assets.foursightonline.com/app/images/team-report-icon.jpg);\n  width: 30px;\n  background-size: cover;\n  height: 23px;\n  display: inline-block;\n  background-repeat: no-repeat;\n}\n\n.gray-scale {\n  filter: grayscale(1);\n}\n\n.select-color {\n  color: #000;\n}\n\n.session-actions {\n  width: 9%;\n  padding: 5px;\n  text-align: right;\n\n  a {\n    position: static;\n    margin-bottom: 0;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .teams-lists .team-actions .btn-xs {\n    display: block;\n  }\n\n  .session-actions a {\n    margin-bottom: 5px;\n  }\n\n  .session-actions a:last-child {\n    margin-bottom: 0;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .page-heading .col-lg-10 {\n    width: auto;\n  }\n\n  .right-side-btn {\n    float: none !important;\n    width: 100%;\n    text-align: left;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    display: inline-block;\n  }\n\n}\n\n@media screen and (max-width: 400px) {\n  .table-striped {\n    width: 400px;\n  }\n}\n\n::ng-deep.swal2-icon-text {\n  font-size: 1.3em;\n  line-height: 1;\n}\n\n::ng-deep.grey {\n  background: rgba(236, 236, 236, 0.9);\n}\n\ntd.team-actions {\n  min-width: 116px;\n\n  &>a {\n    position: relative;\n  }\n\n  .btn-xs:nth-child(2n) {\n    left: unset;\n  }\n}\n\nspan.sortby {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  text-align: right;\n  left: 0px;\n  z-index: 99999;\n  padding-right: 14px;\n}\n\n// Modal Design\n::ng-deep .modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n\n  &.show {\n    display: block !important;\n  }\n\n  &.grey {\n    background: rgba(236, 236, 236, 0.9);\n  }\n\n  &.fade {\n    .modal-dialog {\n      transition: transform 0.3s ease-out;\n    }\n\n    &.in {\n      opacity: 1;\n    }\n  }\n\n  &.in {\n    .modal-dialog {\n      transform: translate(0, 0);\n    }\n  }\n\n  &.modal-open {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px;\n\n    @media (min-width: 768px) {\n      width: 600px;\n      margin: 30px auto;\n    }\n\n    .modal-content {\n      background-clip: padding-box;\n      background-color: #FFFFFF;\n      border: 1px solid rgba(0, 0, 0, 0);\n      border-radius: 4px;\n      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n      outline: 0 none;\n      position: relative;\n\n      .close {\n        float: right;\n        font-size: 21px;\n        font-weight: bold;\n        line-height: 1;\n        color: #000;\n        text-shadow: 0 1px 0 #fff;\n        filter: alpha(opacity=20);\n        opacity: 0.2;\n\n        &:focus-visible {\n          outline: none;\n        }\n      }\n\n      button.close {\n        padding: 0;\n        cursor: pointer;\n        background: transparent;\n        border: 0;\n        -webkit-appearance: none;\n        appearance: none;\n      }\n\n      .modal-body {\n        padding: 20px 30px 30px 30px;\n        position: relative;\n\n        form {\n          label {\n            display: inline-block;\n            max-width: 100%;\n            margin-bottom: 5px;\n            font-weight: 700;\n          }\n\n          input[type=text] {\n            width: 100%;\n            color: inherit;\n            display: block;\n            font-size: 14px;\n            line-height: 1.4;\n            padding: 6px 12px;\n            border-radius: 1px;\n            background-image: none;\n            background-color: #fff;\n            border: 1px solid #e5e6e7;\n            transition: border-color .15s ease-in-out 0s, box-shadow .15s ease-in-out 0s;\n\n            &::-webkit-input-placeholder {\n              color: #999;\n            }\n\n            &:focus,\n            &:focus-visible {\n              border-color: #1ab394;\n              outline: none;\n            }\n          }\n        }\n\n        &.no-pad {\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  .f-btn {\n    color: #fff;\n    font-size: 14px;\n    border-color: #73BF38;\n    background-color: #73BF38;\n\n    &:hover {\n      border-color: #4cae4c;\n      background-color: #4cae4c;\n    }\n\n    &--dngr {\n      color: #fff;\n      border-color: #ED5565;\n      background-color: #ED5565;\n\n      &:hover {\n        border-color: #ec4758;\n        background-color: #ec4758;\n      }\n    }\n\n    &--info {\n      color: #fff;\n      font-size: 12px;\n      line-height: 1.5;\n      padding: 5px 10px;\n      border-color: #23c6c8;\n      background-color: #23c6c8;\n\n      &:hover {\n        border-color: #21b9bb;\n        background-color: #21b9bb;\n      }\n    }\n\n    &--sgrn {\n      color: #fff;\n      border-color: #1dc5a3;\n      background-color: #1dc5a3;\n\n      &:hover {\n        border-color: #1dc5a3;\n        background-color: #1dc5a3;\n      }\n    }\n\n    &--wrng {\n      color: #fff;\n      border-color: #f8ac59;\n      background-color: #f8ac59;\n\n      &:hover {\n        border-color: #f7a54a;\n        background-color: #f7a54a;\n      }\n    }\n  }\n\n  .hidden {\n    display: none;\n  }\n}\n\n::ng-deep.modal-open {\n  overflow: hidden;\n}\n\n.teams-lists {\n  input, select {\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.input-sm {\n  &:focus {\n    outline: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
